import { NumberInput } from '@tremor/react';
import { ChangeEventHandler, ReactElement, useState } from 'react';
import { FORBIDDEN_NUMBER_INPUTS } from '../(dashboards)/utilities/constants';
import { CY_SELECTORS } from '../../cypress/constants';
import { addCypressSelector } from '../commons/utils/utils';
interface EditableNumberFieldProps {
  label?: string;
  isShowLabel?: boolean;
  placeholder?: string;
  id: string;
  value: number | string;
  changeEvent: ChangeEventHandler<HTMLInputElement>;
  error?: string;
  isDisabled?: boolean;
}
const EditableNumberField = ({
  label,
  id,
  value,
  changeEvent,
  error,
  placeholder,
  isShowLabel = true,
  isDisabled = false
}: EditableNumberFieldProps): ReactElement => {
  const [showError, setShowError] = useState(false);
  const handleMouseEnter = (): void => {
    if (error) setShowError(true);
  };
  const handleMouseLeave = (): void => {
    setShowError(false);
  };
  const handleWheel = (event: React.WheelEvent<HTMLInputElement>): void => {
    event.currentTarget.blur();
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (FORBIDDEN_NUMBER_INPUTS.includes(event.key)) {
      event.preventDefault();
    }
  };
  const handleChangeNumberOnly = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const {
      value
    } = e.target;
    changeEvent(e);
  };
  return <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className='flex-grow' data-sentry-component="EditableNumberField" data-sentry-source-file="EditableNumberField.tsx">
      {isShowLabel && <label htmlFor={id}>{label}</label>}
      <NumberInput {...addCypressSelector(CY_SELECTORS.NUMBER_INPUT)} placeholder={placeholder || 'Type'} error={error ? true : false} errorMessage={showError ? error : ''} id={id} value={value} onChange={handleChangeNumberOnly} onKeyDown={handleKeyDown} enableStepper={false} disabled={isDisabled} onWheel={handleWheel} data-sentry-element="NumberInput" data-sentry-source-file="EditableNumberField.tsx" />
    </div>;
};
export default EditableNumberField;